import { createModel } from "@@/package/utils/ModelUtil";
import { CourseStatusType } from "~~/package/mapper/course/model/CourseStatusType";
import { CourseSkillModel } from "~~/package/mapper/course/model/CourseSkillModel";
import { CourseLearningPositionModel } from "~~/package/mapper/course/model/CourseLearningPositionModel";
import type CourseRecentlyResponse from "~~/package/apis/course/response/CourseRecentlyResponse";

export class CourseRecentlyModel {
    constructor(
        public id: number = 0,
        public title: string = "",
        public progress: number = 0,
        public status: CourseStatusType = CourseStatusType.NOT_STARTED,
        public currentSkill: CourseSkillModel = new CourseSkillModel(),
        public learningPosition: CourseLearningPositionModel = new CourseLearningPositionModel()
    ) {
    }

    public static create(model: Partial<CourseRecentlyResponse>): CourseRecentlyModel {
        return createModel<CourseRecentlyModel>(CourseRecentlyModel, {
            ...model
        });
    }
}
